import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_VIDA_URL;

export default {
  getToken() {
    return localStorage.getItem('user-token');
  },

  async getRenewals(params) {
    const response = await axios.get(`${apiUrl}/renewals`, {
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
      },
      params,
    });
    return response.data;
  },

  async exportRenewals(params) {
    const response = await axios.get(`${apiUrl}/renewals/export`, {
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
      },
      params,
      responseType: 'arraybuffer',
    });
    return response.data;
  },

  async createRenewalQuotation(policyId) {
    const response = await axios.post(
      `${apiUrl}/renewals/${policyId}/quotations`,
      {},
      {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      },
    );
    return response.data;
  },
};
